import { useMemo } from 'react';
export function useHasUrlValidationRule(validationRules) {
  return useMemo(() => {
    if (!validationRules || !Array.isArray(validationRules)) {
      return false;
    }
    return validationRules.some(rule => rule.ruleType === 'URL');
  }, [validationRules]);
}